import React from 'react';
import Button from '../../../../../components/Button';
import './BrandDetailProductRegisterHeader.scss';

const BrandDetailProductRegisterHeader = ({ isEditable, edit, cancelEdit }) => {
  return (
    <div className="brandDetailProductRegisterHeader">
      {isEditable ? (
        <div className="buttons">
          <Button type="submit" color="primary" text="저장하기" />
          <Button type="button" text="취소하기" onClick={cancelEdit} />
        </div>
      ) : (
        <Button type="button" color="primary" text="편집하기" onClick={edit} />
      )}
    </div>
  );
};

export default BrandDetailProductRegisterHeader;
